import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SettingsResolver } from './resolvers/settings.resolver';
import { SettingEffects } from './store/effects/setting.effects';
import * as farmSettingsReducer from './store/reducers/farm-settings.reducer';
import * as settingReducer from './store/reducers/setting.reducer';
import { FarmSettingsResolver } from './store/resolvers/farm-settings.resolver';

export function provideSettingsFeature() {
  return makeEnvironmentProviders([
    provideState('settingModule', settingReducer.reducer),
    provideState('farmSettingsModule', farmSettingsReducer.reducer),
    provideEffects(SettingEffects),
    SettingsResolver,
    FarmSettingsResolver,
  ]);
}
